import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SessionStorageService } from './sessionstorage.service';

@Injectable()
export class RoutingService {
  constructor(
    private _router: Router,
    private _storage: SessionStorageService
  ) { }

  private readonly KEY: string = 'HDS_CHECK_POINT';

  navigate(route: any[], saveCheckPoint: boolean = false, customRoute: string = null) {
    if (saveCheckPoint) {
      const routes: string[] = [customRoute ? customRoute : this._router.url];
      const r = this._storage.getData(this.KEY);
      if (r) {
        routes.push(JSON.parse(r)[0]);
      }

      this._storage.saveData(this.KEY, JSON.stringify(routes));
    }
    this._router.navigate(route);
  }

  goToCheckPoint(defaultRoute: any[]) {
    let checkPoint: any[];
    const r = this._storage.getData(this.KEY);
    if (r) {
      const rs: string[] = JSON.parse(r);
      checkPoint = [rs[0]];
      rs.splice(0, 1);
      if (rs.length > 0) {
        this._storage.saveData(this.KEY, JSON.stringify(rs));
      } else {
        this._storage.clearData(this.KEY);
      }
    }

    this._router.navigate(checkPoint ? checkPoint : defaultRoute);
  }
}
